import FacebookHoverIcon from "@assets/images/icons/icon-facebook-hover.webp";
import FacebookIcon from "@assets/images/icons/icon-facebook.webp";
import InstagramHoverIcon from "@assets/images/icons/icon-ig-hover.webp";
import InstagramIcon from "@assets/images/icons/icon-ig.webp";

type Social = {
  hoverIcon: string;
  icon: string;
  platform: string;
  url: string;
};

export const SOCIALS: Social[] = [
  {
    hoverIcon: FacebookHoverIcon,
    icon: FacebookIcon,
    platform: "Facebook",
    url: "https://www.facebook.com/mollyfactory",
  },
  {
    hoverIcon: InstagramHoverIcon,
    icon: InstagramIcon,
    platform: "Instagram",
    url: "https://www.instagram.com/mollyfactory.official/",
  },
];
